import { ErrorMessage } from 'formik'
import React from 'react'
import { InputGroup } from 'react-bootstrap'
import ReactSelect from '../../components/ReactSelect'
import TextError from '../../components/TextError'
import { getUniqueListBy } from '../../lib/AllGlobalFunction'
import { isAllowPriceVariant } from '../../lib/AllStaticVariables'
import {
  handleColorChange,
  handlePriceVariant,
  handleSizeTypeChange
} from './productUtils/productFunctions'

const FeaturesAndAttributes = ({
  values,
  setFieldValue,
  resetForm,
  allState,
  errors,
  touched
}) => {
  return (
    <div>
      {!values?.isExistingProduct && allState?.color?.length > 0 && (
        <div className='col-md-4'>
          <div className='input-file-wrapper mb-3'>
            <label className='form-label required'>Select Color</label>
            <ReactSelect
              id='productColorMapping'
              name='productColorMapping'
              isRequired
              errors={errors?.productColorMapping}
              touched={touched?.productColorMapping}
              placeholder='Select Color'
              value={
                values?.colorId && {
                  value: values?.colorId,
                  label: values?.colorName
                }
              }
              options={allState?.color?.map(({ id, name }) => ({
                value: id,
                label: name
              }))}
              onChange={(e) => {
                handleColorChange({
                  color: { colorId: e?.value, colorName: e?.label },
                  values,
                  resetForm
                })
              }}
            />
          </div>
        </div>
      )}

      {allState?.sizeType?.length > 0 && !values?.isExistingProduct && (
        <div className='row'>
          <div className='col'>
            <div className='input-file-wrapper mb-3'>
              <label className='form-label required'>Size Type</label>
              <div className='d-flex align-items-center gap-3 flex-wrap '>
                {getUniqueListBy(allState?.sizeType, 'sizeTypeID')?.map(
                  ({ sizeTypeName, sizeTypeID }) => (
                    <InputGroup className='custom_checkbox' key={sizeTypeID}>
                      <InputGroup.Radio
                        id='sizeId'
                        checked={sizeTypeID === values?.sizeId ? true : false}
                        disabled={
                          values?.isExistingProduct || values?.productId
                            ? true
                            : false
                        }
                        onChange={(e) => {
                          handleSizeTypeChange({
                            size: {
                              sizeTypeName,
                              sizeTypeID
                            },
                            values,
                            resetForm,
                            sizeType: allState?.sizeType
                          })
                        }}
                      />
                      <label className='custom_label' htmlFor={sizeTypeID}>
                        {sizeTypeName}
                      </label>
                    </InputGroup>
                  )
                )}
              </div>
              <ErrorMessage name='sizeId' component={TextError} />
            </div>
          </div>
        </div>
      )}

      {isAllowPriceVariant && values?.isAllowPriceVariant && values?.sizeId && (
        <div className='col-md-3 mt-auto mb-2'>
          <InputGroup className='custom_checkbox'>
            <InputGroup.Checkbox
              id='isSizeWisePriceVariant'
              checked={values?.isSizeWisePriceVariant ? true : false}
              onChange={(e) => {
                handlePriceVariant({
                  values,
                  resetForm,
                  checked: e?.target?.checked
                })
              }}
            />
            <label className='custom_label' htmlFor='isSizeWisePriceVariant'>
              Has Price Variants
            </label>
          </InputGroup>
        </div>
      )}
    </div>
  )
}

export default FeaturesAndAttributes
